import React from "react";
import { Trophy, Sparkles } from "lucide-react";

const CongratsModal = ({ isOpen, points, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-[999] flex items-center justify-center p-4 transition-all duration-300">
      {/* Modal Container */}
      <div className="relative bg-gradient-to-br from-[#1e2738] via-[#111827] to-[#1e2738] border-2 border-cyan-500/30 rounded-3xl p-8 max-w-sm w-full text-center shadow-[0_0_50px_rgba(6,182,212,0.25)] flex flex-col items-center gap-6 overflow-hidden">
        
        {/* Decorative corner glows */}
        <div className="absolute -top-10 -left-10 w-24 h-24 bg-cyan-500/10 rounded-full blur-2xl pointer-events-none"></div>
        <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-purple-500/10 rounded-full blur-2xl pointer-events-none"></div>

        {/* Sparkles / Stars decor */}
        <div className="absolute top-8 left-8 text-yellow-400/60 animate-pulse">
          <Sparkles className="w-5 h-5" />
        </div>
        <div className="absolute top-12 right-12 text-yellow-400/60 animate-pulse delay-75">
          <Sparkles className="w-6 h-6" />
        </div>

        {/* Circular Trophy Container */}
        <div className="w-20 h-20 bg-gradient-to-tr from-amber-500/20 via-yellow-400/30 to-amber-500/20 border-2 border-yellow-400/40 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/10 mt-2">
          <Trophy className="w-10 h-10 text-yellow-400 animate-bounce" />
        </div>

        {/* Header Message */}
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-medium text-gray-300 tracking-wide">
            YOU WON!
          </h2>
          <h1 className="bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-500 bg-clip-text text-transparent font-black text-3xl tracking-widest">
            CONGRATULATIONS!
          </h1>
        </div>

        {/* Points Pill */}
        <div className="w-full px-6 py-4 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 border border-cyan-500/20 rounded-2xl flex flex-col items-center justify-center shadow-inner shadow-cyan-500/5">
          <span className="text-cyan-400 font-black text-4xl tracking-wider">
            {points || 0}
          </span>
          <span className="text-cyan-200/80 font-bold text-xs uppercase tracking-widest mt-1">
            REWARD POINTS
          </span>
        </div>

        {/* Explanatory Text */}
        <p className="text-gray-300 text-sm leading-relaxed px-2">
          Thank you for verifying your number! Your exclusive reward is waiting for you on the next screen.
        </p>

        {/* Action Button */}
        <button
          onClick={onClose}
          className="w-full py-4 mt-2 bg-gradient-to-r from-[#00D9FF] to-[#00A3FF] text-black font-extrabold text-base rounded-xl shadow-[0_4px_20px_rgba(0,217,255,0.3)] hover:shadow-[0_4px_30px_rgba(0,217,255,0.5)] active:scale-95 hover:brightness-110 transition-all cursor-pointer border-none outline-none uppercase tracking-wider"
        >
          Continue to Claim
        </button>

      </div>
    </div>
  );
};

export default CongratsModal;
